<template>
  <div class="mapbox">
    <div :style="`height:${this.height}; width:${this.width}`" id="map"></div>
  </div>
</template>

<script>
import mapboxgl from "mapbox-gl";

export default {
  name: "mapbox",
  data: () => ({
    map: null,
    token:
      "pk.eyJ1IjoiY2FuY3JvZXVyb3BldSIsImEiOiJjazF0aWdmeXMwMnNhM2tsd3d5c2NvOGt2In0.WDTAx2p2BmZNlXLIGg3RSg"
  }),
  props: {
    position: {
      type: Array
    },
    zoom: {
      type: Number
    },
    width: {
      type: String,
      required: true,
      default: "500"
    },
    height: {
      type: String,
      required: true,
      default: "400"
    },
    json: {
      type: Object
    },
    points: {
      type: Array
    }
  },
  // watch: {
  //   points: function(newVal) {
  //     this.setDataMap(newVal);
  //     console.log(newVal);
  //   },
  // },
  methods: {
    // setDataMap() {
    //   console.log(this.map.getSource());
    // },
    createMap(points) {
      this.map.addControl(new mapboxgl.NavigationControl());
      if (this.json != null) {
        this.map.on("load", () => {
          this.map.addLayer({
            id: "route",
            type: "line",
            source: {
              type: "geojson",
              data: this.json
            },
            layout: {
              "line-join": "round",
              "line-cap": "round"
            },
            paint: {
              "line-color": "#00FF00",
              "line-width": 1
            }
          });
        });
      }
      if (points != undefined) {
        this.map.on("load", () => {
          this.map.addLayer({
            id: "population",
            type: "circle",
            source: {
              type: "geojson",
              data: {
                type: "FeatureCollection",
                features: points
              }
            },
            paint: {
              "circle-radius": 6,
              "circle-color": "#B42222"
            }
          });
          this.map.resize();
        });
      }
    }
  },
  mounted() {
    mapboxgl.accessToken = this.token;

    this.map = new mapboxgl.Map({
      container: "map",
      zoom: this.zoom,
      attributionControl: false,
      center: this.position,
      style: "mapbox://styles/mapbox/satellite-streets-v11"
    });
    this.createMap(this.points);
  }
};
</script>

<style lang="scss" scoped></style>
